"use strict";
const analyserV2 = function () {
    let promiseResolve, widgetPromise;
    const default_config_private = {
        "bank_statement_info": {},
        "templates": {},
        "html": {
            "config": {
                "account_info": {
                    "classes": {
                        "card_item": "owl-theme"
                    }
                },
                "transactions": {
                    "classes": {
                        "data_head": "data-head",
                        "data_left_fixed": "dataLeft-fixed",
                        "mid_panel": "mid-panel",
                        "data_row": "data-row"
                    }
                },
                "monthly_line_item": {
                    "classes": {
                        "card_item": "owl-theme"
                    }
                },
                "high_order_value": {
                    "classes": {
                        "card_item": "owl-theme"
                    }
                },
                "debt_analysis": {
                    "classes": {
                        "card_item": "owl-theme"
                    }
                },
                "trend_analysis": {
                    "classes": {
                        "card_item": "owl-theme"
                    }
                },
                "ebitda_schedule": {
                    "classes": {
                        "card_item": "owl-theme"
                    }
                }
            }
        },
        "owl_carousel": {
            "loop": false,
            "margin": 25,
            "nav": true,
            "responsive": {
                0: {
                    items: 1
                },
                600: {
                    items: 3
                },
                1000: {
                    items: 4
                }
            }
        },
        "_default_option": "All",
        "months": ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        "_months": {
            "Jan": 1,
            "Feb": 2,
            "Mar": 3,
            "Apr": 4,
            "May": 5,
            "Jun": 6,
            "Jul": 7,
            "Aug": 8,
            "Sep": 9,
            "Oct": 10,
            "Nov": 11,
            "Dec": 12
        },
        "img_extension": ".jpg",
        "default_img": "defaultbank",
        "charts": {
            "transactions": {
                "width": 550,
                "height": 400,
                "margin": { top: 20, right: 10, bottom: 20, left: 30 },
                "bar_padding": 0.1,
                "bar_margin": 3,
                "axis_ticks": { qty: 5, outer_size: 0 },
                "color": {
                    "bars": {
                        "field1": "#47bff2"
                    }
                },
            },
            "consolidated_debt_analysis": {
                "x_axis": "model_name",
                "height": 320,
                "margin": { "top": 20, "right": 10, "bottom": 20, "left": 50 },
                "bar_padding": 0.5,
                "bar_margin": 10,
                "axis_ticks": { "qty": 12, "outer_size": 0 },
                "color": { "bars": {} },
            },
            "consolidated_monthly_activity": {
                "x_axis": "model_name",
                "height": 350,
                "margin": { "top": 20, "right": 10, "bottom": 20, "left": 50 },
                "bar_padding": 0.4,
                "bar_margin": 3,
                "chart1_keys": {
                    "model_name": "month_year",
                    "field1": "revenue",
                    "field2": "expense",
                    "field3": "avg_daily_balance",
                },
                "chart2_keys": {
                    "model_name": "month_year",
                    "field1": "transfer_in",
                    "field2": "transfer_out",
                },
                "axis_ticks": { "qty": 12, "outer_size": 0 }
            },
            "consolidated_trend_analysis": {
                "id": ".trend-analysis-graph",
                "offset_height": 300,
                "height": 350,
                "padding": 0,
                "duration": 250,
                "lineOpacity": "0.55",
                "lineOpacityHover": "0.85",
                "otherLinesOpacityHover": "0.1",
                "lineStroke": "1.5px",
                "lineStrokeHover": "2.5px",
                "circleOpacity": '0.85',
                "circleOpacityOnLineHover": "0.25",
                "circleRadius": 5,
                "circleRadiusHover": 6,
                "left": 6,
                "curve": true,
                "callback": "comparisionEvent",
            },
            "consolidated_monthly_line_item": {
                "config": {
                    "id": "#monthlyLineItemCreditChart",
                    "offset_height": 235,
                    "height": 350,
                    "margin": 40,
                    "duration": 250,
                    "lineOpacity": "0.55",
                    "lineOpacityHover": "0.85",
                    "otherLinesOpacityHover": "0.1",
                    "lineStroke": "1.5px",
                    "lineStrokeHover": "2.5px",
                    "circleOpacity": '0.85',
                    "circleOpacityOnLineHover": "0.25",
                    "circleRadius": 3,
                    "circleRadiusHover": 6,
                    "left": 8,
                    "curve": false,
                    "color": ["rgb(23, 140, 220)"],
                    "tooltip": {
                        "top": 10,
                        "left": 0,
                    },
                    "data": [
                        {
                            "name": "Debit",
                            "from": "left",
                        }
                    ]
                },
                "config1": {
                    "id": "#monthlyLineItemDebitChart",
                    "offset_height": 235,
                    "height": 350,
                    "margin": 50,
                    "duration": 250,
                    "lineOpacity": "0.55",
                    "lineOpacityHover": "0.85",
                    "otherLinesOpacityHover": "0.1",
                    "lineStroke": "1.5px",
                    "lineStrokeHover": "2.5px",
                    "circleOpacity": '0.85',
                    "circleOpacityOnLineHover": "0.25",
                    "circleRadius": 3,
                    "circleRadiusHover": 6,
                    "curve": false,
                    "color": ["rgb(23, 140, 220)"],
                    "tooltip": {
                        "top": 0,
                    },
                    "left": 652,
                    "data": [
                        {
                            "from": "left",
                            "name": "Credit",
                        }
                    ]
                }
            }
        },
        "table_divs": {
            "consolidated_monthly_activity": [
                {
                    "target": {
                        "header": "dataLeftFixedMonthlyActivity",
                        "row": "dataLeftFixedMonthlyActivity"
                    },
                    "columns": ["month_year"]
                },
                {
                    "target": {
                        "header": "data-head",
                        "row": "midPanelMonthlyActivity"
                    },
                    "row_parent": { "class": "data-row" },
                },
                {
                    "target": {
                        "header": "dataRightFixedMonthlyActivity",
                        "row": "dataRightFixedMonthlyActivity"
                    },
                    "columns": ["avg_daily_balance"]
                }
            ],
            "transactions": [
                {
                    "target": {
                        "header": "dataLeft-fixed",
                        "row": "dataLeft-fixed"
                    },
                    "columns": ["bank_name"]
                },
                {
                    "target": {
                        "header": "data-head-trns",
                        "row": "mid-panel-trns"
                    },
                    "row_parent": {
                        "class": "data-row",
                    },
                }
            ],
            "consolidated_trend_analysis": [
                {
                    "target": {
                        "header": "dataLeftFixedConsolidatedTrendAnalysis",
                        "row": "dataLeftFixedConsolidatedTrendAnalysis"
                    },
                    "columns": ["group_name"]
                },
                {
                    "target": {
                        "header": "midPanelDataHeadConsolidatedTrendAnalysis",
                        "row": "midPanelConsolidatedTrendAnalysis"
                    },
                    "row_parent": {
                        "class": "data-row"
                    }
                },
                {
                    "target": {
                        "header": "dataRightFixedConsolidatedTrendAnalysis",
                        "row": "dataRightFixedConsolidatedTrendAnalysis"
                    },
                    "columns": ["total"]
                }
            ],
            "consolidated_monthly_line_item": [
                {
                    "target": {
                        "header": "monthlyLineItemLeft",
                        "row": "monthlyLineItemLeft"
                    },
                    "columns": ["transaction"]
                },
                {
                    "target": {
                        "header": "monthlyLineItemLeft1",
                        "row": "monthlyLineItemLeft1"
                    },
                    "columns": ["category"]
                },
                {
                    "target": {
                        "header": "monthlyLineItemDataHead",
                        "row": "monthlyLineItemMidPanel"
                    },
                    "row_parent": {
                        "class": "data-row"
                    },
                }
            ]
        },
        "_consolidated_monthly_activity": {
            "graph1": {
                "color_codes": ["#158cdc", "#fe9006", "#079e89"],
                "legends": ["revenue", "expense", "avg_daily_balance"],
                "legends_value": ["Revenue", "Operating Expense", "Average Daily Balance"],
            },
            "graph2": {
                "color_codes": ["#158cdc", "#fe9006"],
                "legends": ["transfer_in", "transfer_out"],
                "legends_value": ["Transfer In", "Transfer Out"],
            }
        },
        "_consolidated_trend_analysis": {
            "trend_analysis_graph": {
                "class": "trend-analysis-graph"
            },
            "comparision_filter_options": ["percentage_revenue", "percentage_expense", "percentage_debt", "percentage_transfer"],
            "is_left_card_on": true,
            "is_right_card_on": true,
            "last_selected_variable1_option": "revenue",
            "last_selected_variable2_option": "expense",
            "_default_option_config": {
                "callback": { "name": "separateNumberByCommaAndRoundOffwithSign" },
                "config": {
                    "header": { "class": "label-block" },
                    "row": { "class": "label-block" }
                }
            }
        },
        "_consolidated_debt_analysis": {
            "_default_option_config": {
                // "callback": { "name": "separateNumberByDelimiterWithSignAndThousand" },
                "callback": { "name": "separateNumberByCommaAndRoundOffwithSign" },
                "config": {
                    "header": { "class": "label-block" },
                    "row": { "class": "label-block" }
                }
            }
        },
        "_consolidated_monthly_line_item": {
            "_default_option_config": {
                "callback": { "name": "separateNumberByCommaAndRoundOffwithSign" },
                "config": {
                    "header": {  "class": "label-block col" },
                    "row": { "class": "label-block col" }
                }
            }
        },
        "_ebitda_schedule": {
            "current_debt": 0,
            "future_debt": 0,
            "original": {
                "current_debt": 0,
                "future_debt": 0
            },
            "selected_option": "yearly",
            "proposed_debt_amount": {
                "value": 0
            },
            "current_selected_option": "yearly",
            "quarter_filter_option": ["monthly", "quarterly", "half", "yearly"],
            "DSCRSchedule": [
                {
                    "target": {
                        "header": "dscrScheduleDataLeftFixed",
                        "row": "dscrScheduleDataLeftFixed"
                    },
                    "columns": ["group"]
                },
                {
                    "target": {
                        "header": "dscrScheduleDataHead",
                        "row": "dscrScheduleMidPanel"
                    },
                    "row_parent": {
                        "class": "row data-row m-0"
                    },
                }
            ],
            "est_operating_profit_schedule": {
                "columns": {
                    "classification": {
                        "config": {
                            "header": {
                                "class": "col",
                            },
                            "row": {
                                "class": "col"
                            }
                        }
                    },
                    "group": {
                        "config": {
                            "header": {
                                "class": "col",
                            },
                            "row": {
                                "class": "col"
                            }
                        }
                    },
                    "average_monthly_cash_flow ($)": {
                        "config": {
                            "header": {
                                "class": "col-3",
                            },
                            "row": {
                                "class": "col-3"
                            }
                        }
                    },
                    "annual_cash_flow ($)": {
                        "config": {
                            "header": {
                                "class": "col",
                            },
                            "row": {
                                "class": "col"
                            }
                        }
                    }
                },
                "headers": ['classification', 'group', 'average_monthly_cash_flow ($)', 'annual_cash_flow ($)']
            },
            "existing_debt_service": {
                "table_divs": [
                    {
                        "target": {
                            "header": "existingDebtServiceHeader",
                            "row": "existingDebtServiceRow"
                        },
                        "row_parent": {
                            "class": "row data-row"
                        },
                    }
                ],
                "columns": {
                    "classification": {
                        "config": {
                            "header": {
                                "class": "col",
                            },
                            "row": {
                                "class": "col font-b1"
                            }
                        }
                    },
                    "average_monthly_cash_flow": {
                        "config": {
                            "header": {
                                "class": "col",
                            },
                            "row": {
                                "class": "col"
                            }
                        }
                    },
                    "average_annual_cash_flow": {
                        "config": {
                            "header": {
                                "class": "col",
                            },
                            "row": {
                                "class": "col"
                            }
                        }
                    }
                }
            },
            "dscr_calculations": {
                "table_divs": [
                    {
                        "target": {
                            "header": "dscrCalculationsHeader",
                            "row": "dscrCalculationsRow"
                        },
                        "row_parent": {
                            "class": "row data-row"
                        },
                    }
                ],
                "columns": {
                    "annual_revenue": {
                        "config": {
                            "header": {
                                "class": "col",
                            },
                            "row": {
                                "class": "col font-b"
                            }
                        }
                    },
                    "": {
                        "config": {
                            "header": {
                                "class": "col",
                            },
                            "row": {
                                "class": "col"
                            }
                        }
                    }
                }
            },
            "TLPCalculations": {
                "table_divs": [
                    {
                        "target": {
                            "header": "TLPCalculationsHeader",
                            "row": "TLPCalculationsRow"
                        },
                        "row_parent": {
                            "class": "row data-row"
                        },
                    }
                ],
                "columns": {
                    "loan_info_param": {
                        "config": {
                            "header": {
                                "class": "col",
                            },
                            "row": {
                                "class": "col font-b"
                            }
                        }
                    },
                    "": {
                        "config": {
                            "header": {
                                "class": "col",
                            },
                            "row": {
                                "class": "col editableValue"
                            }
                        }
                    }
                }
            }
        },
        "promiseResolve": promiseResolve
    };

    var default_config = {};

    /**
     * main : getting bank-statement html through config file
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param obj object
     */

    const main = (obj) => {
        default_config = JSON.parse(JSON.stringify({}));
        widgetPromise = new Promise(function (resolve, reject) {
            promiseResolve = resolve;
        });
        initScript.toggleLoader(true, true);
        default_config = JSON.parse(JSON.stringify(default_config_private));
        var disconnectedDeepCopy = JSON.parse(JSON.stringify(obj));
        Object.assign(default_config, disconnectedDeepCopy);
        initApiURL();
        getBankStatementInfo();
        return widgetPromise;
    };

    /**
     * initApiURL : initializing URL's
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param data object
     */

    const initApiURL = (data = undefined) => {
        default_config.apiURL = {
            "statements": {
                "type": "POST",
                "url": getV2URL( default_config.widget_service_api, 'statements', default_config.slugs),
                "processData": false,
                "data": data ? data : default_config.body,
                "dataType": "json",
                "headers": {
                    "Content-Type": "application/json"
                }
            }
        };
    };

    /**
     * initOwlCarousel : initializing owl carousel
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */

    const initOwlCarousel = () => {
        initScript.getHTMLElementByDelimiter("owl-carousel").owlCarousel(default_config.owl_carousel);
    };

    /**
     * getBankStatementInfo : getting bank-statement information as per requirement
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */

    const getBankStatementInfo = () => {
        default_config.security_option = initScript.getObjectValue(default_config, "body.security") || {};
        default_config.defaultOptions = initScript.methodWiseOption(null, default_config.apiURL.statements, default_config.security_option);

        const options = default_config.defaultOptions;
        options.data = JSON.stringify(options.data);
        HttpRequest(options, function (res) {
            if(!!default_config.slugs){
                res = responseV2Interceptor(res,default_config.slugs['statements']);
            }else{
                res = responseInterceptor(res);
            }
            populateData(res && res.data ? res.data.data ? res.data.data : res.data : res);
        });
    };

    /**
     * populateData : populating data
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param bank_statement_resp object
     */

    const populateData = (bank_statement_resp) => {
        initScript.changeHTMLOfAClass(initScript.getHTMLElementByDelimiter(default_config.body.class), "");
        for (let i = 0; i < bank_statement_resp.length; ++i) {
            const resource = bank_statement_resp[i].resource, resource_config = default_config.body.config[resource] || {};
            if (!resource_config.value) resource_config.value = initScript.removeUnderscoreWithCamelCase(resource);
            Object.assign(resource_config, default_config.api_urls || {});
            default_config.bank_statement_info[resource] = bank_statement_resp[i].data;

            if (resource === "ebitda_schedule" || resource.search(/^consolidated_/gm) !== -1) {
                const _resource = resource === "ebitda_schedule" ? "dscr_schedule" : resource.replace(/^consolidated/, "account_level");
                default_config.body.resource = [_resource];
                default_config.defaultOptions.data = JSON.stringify(default_config.body);
                HttpRequest(default_config.defaultOptions, function (res) {
                    initScript.toggleLoader(false, true);
                    if(!!default_config.slugs){
                        res = responseV2Interceptor(res,default_config.slugs['statements']);
                    }else{
                        res = responseInterceptor(res);
                    }
                    res = res && res.data ? res.data.data ? res.data.data : res.data : res;
                    res = initScript.getObjectValue(res, "[0].data");
                    if (!initScript.isEmpty(res)) {
                        default_config.bank_statement_info[_resource] = res;
                        initResource(resource_config, resource);
                    } else addAlertBox("Data not available for this resource!");
                });
            } else {
                initScript.toggleLoader(false, true);
                if (!initScript.isEmpty(default_config.bank_statement_info[resource])) {
                    initResource(resource_config, resource);
                } else addAlertBox("Data not available for this resource!");
            }
        }
    };

    /**
     * initResource : initializing resource
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param resource_config object
     * @param resource string
     */

    const initResource = (resource_config, resource) => {
        initScript.changeHTMLOfAClass(initScript.getHTMLElementByDelimiter(default_config.body.class), initScript.jsonToHTML(templates[resource].main, Object.assign(resource_config, default_config.api_urls ? default_config.api_urls : {})));
        resources.init(default_config, resource);
        initOwlCarousel();
    };

    const resolvePromise = () => {
        promiseResolve({
            "code": 200
        });
    };

    const addAlertBox = (message) => {
        if(document.querySelector(".alert-message-151290")){
            document.querySelector(".alert-message-151290").remove()
        }
        var demo = document.createElement("h4");
        demo.setAttribute("class", "alert-message-151290")
        demo.style.display = "block";
        demo.style.textAlign = "center";
        demo.style.backgroundColor = "rgba(28, 104, 165,0.5)";
        demo.style.padding = "10px 0";
        demo.style.margin = "5px 25px 50px 25px";
        demo.style.borderRadius = "5px";
        demo.setAttribute("onclick", "document.querySelector(\".alert-message-151290\").remove()")
        demo.innerHTML = message;
        document.querySelector("."+default_config.body.class).prepend(demo)
    };

    return {
        main,
        init_owl_carousel: initOwlCarousel,
        resolvePromise,
        addAlertBox
    };
}();
